/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _defineProperty = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.mapDispatchToProps = exports.mapStateToProps = exports.name = exports.CategoryHeader = void 0;

var react_1 = __importDefault(require("react"));

var redux_1 = require("redux");

var brightsmith_core_1 = require("brightsmith-core");

var brightsmith_redux_1 = require("brightsmith-redux");

var DataUtils_1 = __importDefault(require("./utils/DataUtils"));

var BrightsmithDb = brightsmith_core_1.Db.BrightsmithDb;
var name = 'CategoryHeader';
exports.name = name;

var CategoryHeader = function CategoryHeader(_ref) {
  var Frame = _ref.Frame,
      List = _ref.List,
      ListItem = _ref.ListItem,
      Select = _ref.Select,
      theme = _ref.theme,
      styles = _ref.styles;
  return /*#__PURE__*/function (_react_1$default$Pure) {
    _inherits(_class, _react_1$default$Pure);

    var _super = _createSuper(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this, props);
      _this.DISPLAY_TYPE = {
        LIST: 'list',
        SELECT: 'select'
      };
      _this.getDisplayType = _this.getDisplayType.bind(_assertThisInitialized(_this));
      _this.renderCategories = _this.renderCategories.bind(_assertThisInitialized(_this));
      _this.selectCategory = _this.selectCategory.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(_class, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState) {
        var _this$props = this.props,
            categories = _this$props.categories,
            currentCategoryId = _this$props.currentCategoryId;

        if (!currentCategoryId && categories.length > 0) {
          this.selectCategory(categories[0].id);
        }
      }
    }, {
      key: "getDisplayType",
      value: function getDisplayType(props) {
        if (props.select) {
          return this.DISPLAY_TYPE.SELECT;
        }

        return this.DISPLAY_TYPE.LIST;
      }
    }, {
      key: "renderCategories",
      value: function renderCategories() {
        var _this2 = this;

        var categories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var classes = arguments.length > 1 ? arguments[1] : undefined;
        var displayType = arguments.length > 2 ? arguments[2] : undefined;
        var _this$props2 = this.props,
            currentCategory = _this$props2.currentCategory,
            currentCategoryId = _this$props2.currentCategoryId,
            placeholder = _this$props2.placeholder;

        if (displayType === this.DISPLAY_TYPE.SELECT) {
          var options = categories.map(function (c) {
            return {
              label: c.name,
              value: c.id
            };
          });
          var makeStyles = style(theme);
          var currentValue = currentCategoryId ? {
            label: currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.name,
            value: currentCategoryId
          } : options[0];
          return react_1.default.createElement(Frame, {
            className: ["CategoryHeader__select-wrapper", classes === null || classes === void 0 ? void 0 : classes.selectWrapper]
          }, react_1.default.createElement(Select, {
            isSearchable: false,
            onChange: function onChange(selected) {
              return _this2.selectCategory(selected.value);
            },
            options: options,
            placeholder: placeholder,
            style: makeStyles.select,
            value: currentValue
          }));
        }

        return react_1.default.createElement(List, {
          className: ['CategoryHeader__list', classes === null || classes === void 0 ? void 0 : classes.list],
          style: styles === null || styles === void 0 ? void 0 : styles.list
        }, categories.map(function (category) {
          var selected = currentCategoryId === category.id;
          var listItemStyle = Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.listItem);

          if (selected) {
            Object.assign(listItemStyle, styles === null || styles === void 0 ? void 0 : styles.selectedListItem);
          }

          return react_1.default.createElement(ListItem, {
            className: [classes === null || classes === void 0 ? void 0 : classes.listItem, _defineProperty({}, (classes === null || classes === void 0 ? void 0 : classes.selectedListItem) || '', currentCategoryId === category.id)],
            onClick: function onClick() {
              return _this2.selectCategory(category.id);
            },
            style: listItemStyle,
            key: category.id
          }, category.name);
        }));
      }
    }, {
      key: "selectCategory",
      value: function selectCategory(id) {
        var actions = this.props.actions;
        actions.ui.setCurrentCategory(id, true);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props3 = this.props,
            after = _this$props3.after,
            before = _this$props3.before,
            categories = _this$props3.categories,
            classes = _this$props3.classes;
        return react_1.default.createElement(Frame, {
          className: ['CategoryHeader', classes === null || classes === void 0 ? void 0 : classes.container],
          style: styles === null || styles === void 0 ? void 0 : styles.container
        }, before, this.renderCategories(categories, classes, this.getDisplayType(this.props)), after);
      }
    }]);

    return _class;
  }(react_1.default.PureComponent);
};

exports.CategoryHeader = CategoryHeader;

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    actions: {
      ui: {
        setCurrentCategory: redux_1.bindActionCreators(brightsmith_redux_1.Actions.Ui.setCurrentCategory, dispatch)
      }
    }
  };
};

exports.mapDispatchToProps = mapDispatchToProps;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _a;

  var api = state.api,
      ui = state.ui;
  var db = new BrightsmithDb(api);
  var categories = DataUtils_1.default.sort(db.getCategories());
  categories = categories.filter(function (c) {
    var _a;

    return !((_a = c.display) === null || _a === void 0 ? void 0 : _a.hide) && c.active !== false && !c.parentCategory;
  });
  var currentCategoryId = (ui === null || ui === void 0 ? void 0 : ui.currentCategoryId) || ((_a = categories[0]) === null || _a === void 0 ? void 0 : _a.id);
  var currentCategory = db.getCategory(currentCategoryId);
  return {
    categories: categories,
    currentCategory: currentCategory,
    currentCategoryId: currentCategoryId
  };
};

exports.mapStateToProps = mapStateToProps;

var style = function style(theme) {
  var _a, _b, _c, _d, _e, _f;

  return {
    container: Object.assign({
      padding: 5
    }, (_a = theme === null || theme === void 0 ? void 0 : theme.CategoryHeader) === null || _a === void 0 ? void 0 : _a.container),
    list: Object.assign({
      listStyleType: 'none',
      paddingLeft: 5,
      paddingTop: 15
    }, (_b = theme === null || theme === void 0 ? void 0 : theme.CategoryHeader) === null || _b === void 0 ? void 0 : _b.list),
    listItem: Object.assign({
      cursor: 'pointer',
      lineHeight: '18px',
      textTransform: 'uppercase'
    }, (_c = theme === null || theme === void 0 ? void 0 : theme.CategoryHeader) === null || _c === void 0 ? void 0 : _c.listItem),
    select: Object.assign({}, (_d = theme === null || theme === void 0 ? void 0 : theme.CategoryHeader) === null || _d === void 0 ? void 0 : _d.select),
    selectedListItem: Object.assign({
      fontSize: 18,
      fontWeight: 'bold'
    }, (_e = theme === null || theme === void 0 ? void 0 : theme.CategoryHeader) === null || _e === void 0 ? void 0 : _e.selectedListItem),
    selectWrapper: Object.assign({}, (_f = theme === null || theme === void 0 ? void 0 : theme.CategoryHeader) === null || _f === void 0 ? void 0 : _f.selectWrapper)
  };
};

exports.style = style;